// Step 5, "Only when…": always open, optional. Conditions first, then the
// controls: Use as fallback (not Apps), and on SSH only Approval (not for
// Deny) and Session. The header's muted summary says what is set
// ("2 conditions · Fallback on", or "None"). Except lives under Who.
import React from "react";

import { AN_COLORS } from "../../../design-system/tokens";
import { advancedSummaryText } from "../../../components/policyShell/policyModel";
import { ADVANCED_TITLE, FALLBACK_DESC, FALLBACK_LABEL } from "../../../components/policyShell/signals";
import { Muted, Note, StepCard } from "../ui";
import ConditionsSection from "./ConditionsSection";
import { ApprovalSection, SessionSection, SwitchRow } from "./ApprovalSessionSections";
import { advancedState } from "./draft";

export default function AdvancedBlock({ adapter, draft, patchDraft, errors, allErrors, touch, data, warnings = [] }) {
  // Except is counted under Who now.
  const state = { ...advancedState(adapter, draft), exceptCount: 0 };
  const summary = advancedSummaryText(state);
  const f = adapter.features || {};
  const controls = f.fallback || f.fallbackNote || f.approval || f.session;
  const anyError = Object.keys(errors).some((k) => /^(conditions|approval|session)\./.test(k));
  return (
    <StepCard
      id="policy-section-advanced"
      step={5}
      title={ADVANCED_TITLE}
      optional
      help="Narrow when it applies, and how it behaves."
      done={state.conditionCount > 0 || state.fallback || state.approval || state.session}
      error={anyError}
      aside={
        <span data-testid="advanced-summary" style={{ fontSize: "0.8125rem", color: AN_COLORS.muted }}>
          {summary}
        </span>
      }
    >
      <ConditionsSection adapter={adapter} draft={draft} patchDraft={patchDraft} errors={errors} allErrors={allErrors} touch={touch} />
      {warnings.map((w) => (
        <Note key={w} tone="warn">
          {w}
        </Note>
      ))}
      {controls && (
        <div style={{ display: "grid", gap: "1.25rem", borderTop: `1px solid ${AN_COLORS.line2}`, paddingTop: "1.25rem" }}>
          {f.fallback && <SwitchRow label={FALLBACK_LABEL} desc={FALLBACK_DESC} checked={draft.fallback} onChange={(v) => patchDraft({ fallback: v })} />}
          {!f.fallback && f.fallbackNote && <Muted>{f.fallbackNote}</Muted>}
          {f.approval && <ApprovalSection adapter={adapter} draft={draft} patchDraft={patchDraft} errors={errors} touch={touch} data={data} />}
          {f.session && <SessionSection adapter={adapter} draft={draft} patchDraft={patchDraft} errors={errors} touch={touch} />}
        </div>
      )}
    </StepCard>
  );
}
